/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RttrSerialClaimsInfo } from './RttrSerialClaimsInfo';
import {
    RttrSerialClaimsInfoFromJSON,
    RttrSerialClaimsInfoFromJSONTyped,
    RttrSerialClaimsInfoToJSON,
    RttrSerialClaimsInfoToJSONTyped,
} from './RttrSerialClaimsInfo';
import type { RttrQrRedemptionFlags } from './RttrQrRedemptionFlags';
import {
    RttrQrRedemptionFlagsFromJSON,
    RttrQrRedemptionFlagsFromJSONTyped,
    RttrQrRedemptionFlagsToJSON,
    RttrQrRedemptionFlagsToJSONTyped,
} from './RttrQrRedemptionFlags';

/**
 * 
 * @export
 * @interface RttrUserStateResponse
 */
export interface RttrUserStateResponse {
    /**
     * 
     * @type {RttrSerialClaimsInfo}
     * @memberof RttrUserStateResponse
     */
    serialClaims: RttrSerialClaimsInfo;
    /**
     * Combined Master the Realm points (existing-gear + new-gear + quiz), capped at masterOfRealmMax. Drives the "X of 25,000" counter.
     * @type {number}
     * @memberof RttrUserStateResponse
     */
    masterOfRealmTotal: number;
    /**
     * The 25,000 combined cap.
     * @type {number}
     * @memberof RttrUserStateResponse
     */
    masterOfRealmMax: number;
    /**
     * Points earned from Realm karma, keyed by segmentIndex (round)
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    karmaPoints: { [key: string]: number; };
    /**
     * Per-segment redemption status keyed by segmentIndex. Each value carries independent flags for the MineLab and Club tracks — a user can earn both once per round.
     * @type {{ [key: string]: RttrQrRedemptionFlags; }}
     * @memberof RttrUserStateResponse
     */
    qrRedemptions: { [key: string]: RttrQrRedemptionFlags; };
    /**
     * Post count per segment, keyed by segmentIndex
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    socialPosts: { [key: string]: number; };
    /**
     * Whether the user has claimed the follow for each segment, keyed by segmentIndex
     * @type {{ [key: string]: boolean; }}
     * @memberof RttrUserStateResponse
     */
    socialFollows: { [key: string]: boolean; };
    /**
     * Facebook like claim count per segment, keyed by segmentIndex. Sourced from RttrSocialLikeClaim (separate model from social follows).
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    socialLikes: { [key: string]: number; };
    /**
     * Total referrals made by this user for this challenge across all rounds — code signups plus Grow the Realm email invites
     * @type {number}
     * @memberof RttrUserStateResponse
     */
    referralCount: number;
    /**
     * Points earned per segment index from ActivityProgression, keyed by segmentIndex
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    roundPoints: { [key: string]: number; };
    /**
     * Actual points awarded for QR event redemption per segment, keyed by segmentIndex
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    qrPtsPerRound: { [key: string]: number; };
    /**
     * Actual points awarded for social follow per segment, keyed by segmentIndex
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    followPtsPerRound: { [key: string]: number; };
    /**
     * Actual points awarded for
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    postPtsPerRound: { [key: string]: number; };
    /**
     * Actual points awarded for Facebook post likes per segment (sum of RttrSocialLikeClaim.pointsAwarded). Drives the new "Engage to Advance" row on the My Points breakdown.
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    likePtsPerRound: { [key: string]: number; };
    /**
     * Per-segment list of postUrls the user has already claimed a like for. Drives the "lock after claim until next post ships" behavior on the FB-like card — the card stays locked while the currently-configured post URL is in this list, and unlocks automatically when a new URL is deployed.
     * @type {{ [key: string]: Array<string>; }}
     * @memberof RttrUserStateResponse
     */
    socialLikePostUrls: { [key: string]: Array<string>; };
    /**
     * Combined referral slots used per round segment (code-signup referrals + Grow the Realm email invites, shared 3/round cap), keyed by segmentIndex
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    referralCountPerRound: { [key: string]: number; };
    /**
     * Points awarded via wheel-spin RTTR_POINTS rewards per segment, keyed by segmentIndex
     * @type {{ [key: string]: number; }}
     * @memberof RttrUserStateResponse
     */
    wheelSpinPtsPerRound: { [key: string]: number; };
}

/**
 * Check if a given object implements the RttrUserStateResponse interface.
 */
export function instanceOfRttrUserStateResponse(value: object): value is RttrUserStateResponse {
    if (!('serialClaims' in value) || value['serialClaims'] === undefined) return false;
    if (!('masterOfRealmTotal' in value) || value['masterOfRealmTotal'] === undefined) return false;
    if (!('masterOfRealmMax' in value) || value['masterOfRealmMax'] === undefined) return false;
    if (!('karmaPoints' in value) || value['karmaPoints'] === undefined) return false;
    if (!('qrRedemptions' in value) || value['qrRedemptions'] === undefined) return false;
    if (!('socialPosts' in value) || value['socialPosts'] === undefined) return false;
    if (!('socialFollows' in value) || value['socialFollows'] === undefined) return false;
    if (!('socialLikes' in value) || value['socialLikes'] === undefined) return false;
    if (!('referralCount' in value) || value['referralCount'] === undefined) return false;
    if (!('roundPoints' in value) || value['roundPoints'] === undefined) return false;
    if (!('qrPtsPerRound' in value) || value['qrPtsPerRound'] === undefined) return false;
    if (!('followPtsPerRound' in value) || value['followPtsPerRound'] === undefined) return false;
    if (!('postPtsPerRound' in value) || value['postPtsPerRound'] === undefined) return false;
    if (!('likePtsPerRound' in value) || value['likePtsPerRound'] === undefined) return false;
    if (!('socialLikePostUrls' in value) || value['socialLikePostUrls'] === undefined) return false;
    if (!('referralCountPerRound' in value) || value['referralCountPerRound'] === undefined) return false;
    if (!('wheelSpinPtsPerRound' in value) || value['wheelSpinPtsPerRound'] === undefined) return false;
    return true;
}

export function RttrUserStateResponseFromJSON(json: any): RttrUserStateResponse {
    return RttrUserStateResponseFromJSONTyped(json, false);
}

export function RttrUserStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RttrUserStateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serialClaims': RttrSerialClaimsInfoFromJSON(json['serialClaims']),
        'masterOfRealmTotal': json['masterOfRealmTotal'],
        'masterOfRealmMax': json['masterOfRealmMax'],
        'karmaPoints': json['karmaPoints'],
        'qrRedemptions': (mapValues(json['qrRedemptions'], RttrQrRedemptionFlagsFromJSON)),
        'socialPosts': json['socialPosts'],
        'socialFollows': json['socialFollows'],
        'socialLikes': json['socialLikes'],
        'referralCount': json['referralCount'],
        'roundPoints': json['roundPoints'],
        'qrPtsPerRound': json['qrPtsPerRound'],
        'followPtsPerRound': json['followPtsPerRound'],
        'postPtsPerRound': json['postPtsPerRound'],
        'likePtsPerRound': json['likePtsPerRound'],
        'socialLikePostUrls': json['socialLikePostUrls'],
        'referralCountPerRound': json['referralCountPerRound'],
        'wheelSpinPtsPerRound': json['wheelSpinPtsPerRound'],
    };
}

export function RttrUserStateResponseToJSON(json: any): RttrUserStateResponse {
    return RttrUserStateResponseToJSONTyped(json, false);
}

export function RttrUserStateResponseToJSONTyped(value?: RttrUserStateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serialClaims': RttrSerialClaimsInfoToJSON(value['serialClaims']),
        'masterOfRealmTotal': value['masterOfRealmTotal'],
        'masterOfRealmMax': value['masterOfRealmMax'],
        'karmaPoints': value['karmaPoints'],
        'qrRedemptions': (mapValues(value['qrRedemptions'], RttrQrRedemptionFlagsToJSON)),
        'socialPosts': value['socialPosts'],
        'socialFollows': value['socialFollows'],
        'socialLikes': value['socialLikes'],
        'referralCount': value['referralCount'],
        'roundPoints': value['roundPoints'],
        'qrPtsPerRound': value['qrPtsPerRound'],
        'followPtsPerRound': value['followPtsPerRound'],
        'postPtsPerRound': value['postPtsPerRound'],
        'likePtsPerRound': value['likePtsPerRound'],
        'socialLikePostUrls': value['socialLikePostUrls'],
        'referralCountPerRound': value['referralCountPerRound'],
        'wheelSpinPtsPerRound': value['wheelSpinPtsPerRound'],
    };
}

